import React from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box, Paper, Button, Typography } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import useAuth from './context/auth';
import Image from '../../img/background-login.png';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
    padding: '2em',
  },
  background: {
    backgroundImage: `url(${Image})`,
    height: '850px',
    width: '100%',
  },
  sidebar: {
    height: '100%',
    width: '350px',
  },
  textbox: {
    paddingLeft: '40px',
  },
  paperRow: {
    display: 'flex',
    backgroundColor: '#EAEBEB',
    height: '50px',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textboxContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
  },
  outerContainer: {
    height: '100%',
    width: '100%',
  },
  sidebarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
  },
  itemContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: '100%',
    flex: '1',
    maxHeight: '25vh',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '94%',
  },
  button: {
    backgroundColor: '#006bb6',
    '&:hover': {
      backgroundColor: '#006bb6',
      filter: 'brightness(90%)',
    },
    textTransform: 'none',
    fontSize: '15px',
    fontWeight: 'bold',
    marginBottom: '2rem',
    height: '60px',
    width: '150px',
  },
  font1: {
    fontWeight: 'bold',
    fontSize: '19px',
  },
  font2: {
    fontWeight: 'bold',
    fontSize: '15px',
    color: '#464646',
  },
  font3: {
    fontSize: '13px',
  },
}));

const Login = () => {
  const classes = useStyles();
  const { user } = useAuth();
  const history = useHistory();

  const redirect = '/';

  const postLogin = () => {
    Auth.federatedSignIn({
      provider: process.env.REACT_APP_CPMT_COGNITO_IDP,
      customState: JSON.stringify({
        originalUri: history.location.state.referer,
      }),
    });
  };

  if (user) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <Paper className={classes.background}>
        <Grid container className={classes.outerContainer}>
          <Paper className={classes.sidebar} square>
            <Grid container className={classes.sidebarContainer}>
              <Grid item className={classes.itemContainer}>
                <Paper className={classes.paperRow} square>
                  <Typography className={classes.font1}>
                    Please Sign In Below
                  </Typography>
                </Paper>
                <Grid container className={classes.buttonContainer}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={postLogin}
                  >
                    SSO Sign In
                  </Button>
                </Grid>
              </Grid>
              <Grid item className={classes.itemContainer}>
                <Paper className={classes.paperRow}>
                  <Typography className={classes.font1}>
                    Don&apos;t Have an Account?
                  </Typography>
                </Paper>
                <Box p={3}>
                  <Typography className={classes.font2}>
                    Account requests are not accepted at this time.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Paper>
          <Grid item className={classes.textboxContainer} xs={9}>
            <Box m={1} className={classes.textbox}>
              <Typography className={classes.font3}>
                Notice: This computer system may contain US government or other
                customer or third party information, and is only for use by
                authorized users for business purposes. This computer system is
                designed to comply with the requirements of NIST SP 800-171 r2,
                and any data accessed or transmitted to or from this computer
                system must be protected in accordance with the requirements of
                NIST SP 800-171 r2. There is no right of privacy in this
                computer system. Use constitutes consent and acknowledgement
                that the computer system, and any information placed or sent
                over the computer system, is monitored, recorded and subject to
                audit and collection for all lawful purposes including in
                relation to investigations and/or legal proceedings. Any
                unauthorized use, accessing of or attempt to access this
                computer system, or any unauthorized alteration, damage,
                removing, addition, or destruction of any data, program or
                software in this computer system is subject to criminal and
                civil prosecution under state and/or federal law. Unauthorized
                use may result in the delivery of possible evidence collected
                during monitoring to law enforcement officials. Failure to
                comply with this notice may be grounds for disciplinary action,
                up to and including termination and/or civil and criminal
                prosecution.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default Login;
